import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const UsersFeature = {
  // Roles that are eligible for the Users feature
  Roles: [
    MccsRoles.ADMINISTRATOR,
    MccsRoles.CREDENTIALING_ADMIN,
    MccsRoles.CREDENTIALING,
    MccsRoles.CHIEF_INVESTIGATOR,
  ],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(UsersFeature.Roles, user),
} satisfies Feature
